import React from "react";
import { Routes, Route } from "react-router-dom";
import "./App.css";

// Components
import Header2 from "./components/Header2";
import Footer2 from "./components/Footer2";

// Pages
import Home2 from "./pages/Home2";
import Pricing from "./pages/Pricing";
import Workout from "./pages/Workout";
import Gallery from "./pages/Gallery";
import Trainers from "./pages/Trainers";
import Contact from "./pages/Contact";
import Faqs from "./pages/Faqs";
import About from "./pages/About";
import Services from "./pages/Services";

function App() {
  return (
    <div className="App">

      <Header2 />

      <main>
        <Routes>
          <Route path="/" element={<Home2 />} />
          <Route path="/plans" element={<Pricing />} />
          <Route path="/workouts" element={<Workout />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/trainers" element={<Trainers />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/faqs" element={<Faqs />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
        </Routes>
      </main>

      <Footer2 />

    </div>
  );
}

export default App;
